import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// Components
import Navbar from "./components/Navbar";
import Photography from "./components/Photography";
import Rental from "./components/Rental";
import Contact from "./components/Contact";
import GalleryAdmin from "./components/GalleryAdmin";
import ScrollToTop from "./components/ScrollToTop";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

// Pages
import Home from "./pages/Home";
import CategoryGallery from "./pages/CategoryGallery";
import GalleryDetails from "./pages/GalleryDetails";
import AdminLogin from "./pages/AdminLogin";

// Protection
import ProtectedRoute from "./ProtectedRoute";

function App() {
  return (
    <Router>
      <ScrollToTop />

      <Navbar />

      <Routes>

        {/* ================= HOME ================= */}

        <Route
          path="/"
          element={<Home />}
        />

        {/* ================= PHOTOGRAPHY ================= */}

        <Route
          path="/photography"
          element={<Photography />}
        />

        {/* ================= RENTAL ================= */}

        <Route
          path="/rental"
          element={<Rental />}
        />

        {/* ================= CONTACT ================= */}

        <Route
          path="/contact"
          element={<Contact />}
        />

        {/* ================= CATEGORY GALLERY ================= */}

        <Route
          path="/gallery/:type/:category"
          element={<CategoryGallery />}
        />

        {/* ================= GALLERY DETAILS ================= */}

        <Route
          path="/gallery/:type/:category/:albumId"
          element={<GalleryDetails />}
        />

        {/* ================= ADMIN LOGIN ================= */}

        <Route
          path="/admin/login"
          element={<AdminLogin />}
        />

        {/* ================= ADMIN ================= */}

        <Route
          path="/admin"
          element={
            <Navigate
              to="/admin/login"
              replace
            />
          }
        />

        {/* ================= ADMIN GALLERY ================= */}

        <Route
          path="/admin/gallery"
          element={
            <ProtectedRoute>
              <GalleryAdmin />
            </ProtectedRoute>
          }
        />

        {/* ================= 404 ================= */}

        <Route
          path="*"
          element={
            <div
              style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <h1>Page Not Found</h1>
            </div>
          }
        />

      </Routes>

      <Footer />

      <WhatsAppButton />

    </Router>
  );
}

export default App;